//import injectionTarget from "../core/di/DecoratorInjectionTarget";
import type IAuthRepository from "../repositories/interfaces/IAuthRepository";
import { SignInInfo, SignUpInfo } from "@/repositories/dto/auth";
import Container from "../core/di/DependencyContainer.ts";
import BaseService from "./BaseService.ts";
import {useUserStore} from "@/store";
import { PasswordResetInfo } from "@/repositories/dto/auth/PasswordResetInfo.ts";

//@injectionTarget()
export default class AuthService extends BaseService {
  authRepository: IAuthRepository;

  constructor(
    //@inject("authRepository") authRepository?: IAuthRepository
  ) {
    super();
    let authRepository: IAuthRepository | null = Container.get("authRepository");
    // ensures userRepository exists and no checks for undefined are required throughout the class
    if (authRepository == null) {
      throw Error("No AuthRepository provided or injected.");
    }
    this.authRepository = authRepository;
  }

  async signIn(refKey: string, signInInfo: SignInInfo): Promise<void> {
    await this.refWrapper(refKey, async () => {
      const result = await this.authRepository.signIn(signInInfo);
      const userStore = useUserStore()
      await userStore.getState();

      return result;
    });
  }

  async signUp(refKey: string, signUpInfo: SignUpInfo): Promise<void> {
    await this.refWrapper(refKey, () => {
      return this.authRepository.signUp(signUpInfo);
    });
  }

  async passwordReset(refKey: string, passwordReset: PasswordResetInfo): Promise<void> {
    await this.refWrapper(refKey, () => {
      return this.authRepository.resetPassword(passwordReset.email);
    });
  }

  async logout(): Promise<void | Error> {
    try {
      return await this.authRepository.logout();
    } catch (error: any) {
      switch (error.type) {
        default:
          return new Error(error.type);
      }
    }
  }
}
